<p>new-dashboard-item works!</p>
